/**
 * add filtering to About > FAQs, and pre-populate filter based on "care-type" query string variable
 */
const setupFaqs = () =>
{
	const filtersElem    = document.querySelector( '#faq-filters' );
	const accordionElem  = document.querySelector( '#faq-accordion' );
	const presetCareType = new URLSearchParams( location.search ).get( 'care-type' );

	if (filtersElem instanceof HTMLElement && accordionElem instanceof HTMLElement) {

		const buttons        = filtersElem.querySelectorAll( 'button' );
		const accordionItems = accordionElem.querySelectorAll( '.accordion-item' );

		buttons.forEach( button =>
		{
			const tag = button.dataset.tag;

			button.addEventListener( 'click', e =>
			{
				e.preventDefault();

				buttons.forEach( btn =>
				{
					btn.classList.remove( 'btn-primary', 'btn-outline-primary' );
					btn.classList.add( 'btn-outline-primary' );
				} );

				button.classList.remove( 'btn-outline-primary' );
				button.classList.add( 'btn-primary' );

				accordionItems.forEach( item =>
				{
					const tags = item.dataset.tags.split( '|' );

					if (tag === '' || tags.indexOf( tag ) !== -1) {
						item.classList.remove( 'hidden' );
					} else {
						item.classList.add( 'hidden' );
					}
				} );
			} );

			// check query string for care-type=(memory-care|independent-living|assisted-living) and auto select

			if (tag === presetCareType) {
				button.click();
			}
		} );
	}
};


/**
 *
 */
export default setupFaqs;